import React, { Component } from "react"

import TemplateBlock from "./templateBlock"
import { Masonry } from "./masonry"
import { has, clone, set, isEmpty } from "lodash"
import { possibleCatagories } from "../global/contants"
import { Spin, Select } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import { Link } from "gatsby"
import { extract_plugin_name, camelize, camelizePluginList } from "../functions"
import withLocation from "../hoc/withLocation"
import { navigate } from "@reach/router"
const { Option } = Select;
const Loader = <LoadingOutlined style={{ fontSize: 40 }} spin />

class Catagorize extends Component {
  state = {
    possibleCatagories,
    activeTab: "all",
    filters: {
      plugins: null
    },
    filteredTemplates: []
  }

  componentWillMount() {
    const { data, search } = this.props
    const { possibleCatagories } = this.state

    if (!isEmpty(search)) {
      if (  !isEmpty(search.plugin)  ) {
        this.handleFilter('plugins', search.plugin);
      }
    } else {
      this.handleFilter('plugins', null);
    }

    if (has(data, "pageContext") && has(data.pageContext, "catagory")) {
      let catags = possibleCatagories.map(v => v.toLowerCase())
      let tabIndex = catags.findIndex(v => v === data.pageContext.catagory)
      this.setState({ activeTab: tabIndex.toString() })
    }
  }

  handleFilter = ( type , value ) => {

    const { filters } = this.state;
    const { templates } = this.props;

    const newFilters = clone(filters);

    set(newFilters, type, value);

    this.setState({ filters: newFilters } , () => {
      this.setState({ filteredTemplates: this.filterTemplates(this.getPublishedTemplates(templates))  })

      if (typeof document !== 'undefined') {

        const { pathname } = this.props.location;
        
        const plugins = type === 'plugins' ? value : filters.plugin;

        const pluginQuery = plugins !== null ? `?plugin=${plugins}` : ``;

        window.history.pushState(pathname, 'Title', pathname + pluginQuery);


      }

    });


    
  }

  filterTemplates = (templates) => {

    const { filters } = this.state;

    const filteredTemplates = templates.filter(temp => {

      if (!isEmpty(filters.plugins)) {
        const currentPlugins = temp.data.reqPlugins;

        if (!isEmpty(currentPlugins)) {

          let plugins = camelizePluginList(extract_plugin_name(currentPlugins));

          return plugins.includes( camelize(filters.plugins) );

        }
      } else {
        return true;
      }


    });

    return filteredTemplates;

  }

  getPublishedTemplates = templates => {
    return templates.filter(template => template.data.published === true)
  }



  render() {
    const { possibleCatagories, activeTab, filters, filteredTemplates } = this.state
    const { loading, templates, availablePlugins } = this.props


    const getActive = v => {
      if (v === "all" && activeTab === "all") {
        return {
          className: "activeCatag",
        }
      }

      if (v === possibleCatagories[activeTab])
        return {
          className: "activeCatag",
        }
    }

    return (
      <>
        <div className="cwp-home-catags">
          <div className="cwp-links">
          <Link {...getActive("all")} to="/" key="all">
            All
          </Link>
          {possibleCatagories.map((v, i) => (
            <Link {...getActive(v)} key={i} to={`/section/${v.toLowerCase()}`}>
              {v}
            </Link>
          ))}
          </div>
          <div>
            <Select defaultValue={null} value={filters.plugins} onChange={(pl) => this.handleFilter('plugins',  pl)}>
            <Option value={null}>Filter By Plugin</Option>
            {
              availablePlugins && availablePlugins.map((plugin, i) => {
                return <Option key={i} value={plugin}>{plugin}</Option>
              })
            }
          </Select>
          </div>
        </div>

        <div className="masonry cwp-home-main fadeIn">
          {loading ? (
            <div className="cwp-masonry-loader">
              <Spin indicator={Loader} />
            </div>
          ) : (
            <Masonry brakePoints={[350, 500, 750]}>
              {filteredTemplates &&
                filteredTemplates.map((template, index) => (
                  <TemplateBlock template={template} key={index} />
                ))}
            </Masonry>
          )}
        </div>
      </>
    )
  }
}

export default withLocation(Catagorize);
